import Vue from "vue";
import Vuex from "vuex";
import { api } from "@/store/api.module";
import { filehandlingManager } from "@/store/filehandling.module";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    // @ts-ignore
    api,
    filehandlingManager
  }
});
